import { useDropdownContext } from '../Dropdown/DropdownContext';

const DropdownMenu = ({
    className,
    scrollable,
    children,
    onBackgroundClick /* Used to close the menu */,
}: {
    className?: string;
    scrollable?: boolean;
    children?: React.ReactNode;
    onBackgroundClick(): void;
}) => {
    const context = useDropdownContext();

    const closeMenu = () => {
        onBackgroundClick();
    };

    return (
        context.value.isOpen && (
            <>
                <div className={`dropdown--menu ${className ?? ''}`} role="menu" tabIndex={-1}>
                    {scrollable ? <div className="dropdown--scrollable">{children}</div> : children}
                </div>
                <div className="page-cover" onClick={closeMenu}></div>
            </>
        )
    );
};

export default DropdownMenu;
